import React, { useState } from "react";

const apiUrl = process.env.REACT_APP_API_URL;


export default function Apropos() {
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    message: "",
  });

  const [success, setSuccess] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);

    const res = await fetch(`${apiUrl}/api/contact`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(form),
    });

    if (res.ok) {
      setSuccess("✅ Merci, votre message a bien été envoyé.");
      setForm({ firstName: "", lastName: "", email: "", message: "" });

      setTimeout(() => setSuccess(null), 5000);
    } else {
      setSuccess("❌ Une erreur est survenue, veuillez réessayer.");
    }
    setIsSubmitting(false);
  };

  return (
    <section className="relative px-6 py-12 max-w-7xl mx-auto">
      {/* 🎨 Illustration en fond */}
      <img
        src="/images/phantom/fantome1.png"
        alt="Phantom Illustration"
        className="absolute top-40 left-0 md:left-36 w-32 md:w-72 opacity-70 z-0 pointer-events-none"
        loading="lazy"
      />
      {/* Texte + image */}
      <div className="relative z-10 grid md:grid-cols-2 gap-10 items-center">
        <div className="space-y-4 ">
          <h2 className="text-4xl font-bold">À propos</h2>

          <p className="text-md font-semibold text-gray-700">
            SAME, est une marque de streetwear inclusive, souhaitant réunir et
            rassembler les amateurs de streetwear d’horizons différents en
            invitant les membres à créer eux même leur pièces grâce à des
            options de personnalisation diverse.
          </p>
          <p className="text-md font-semibold text-gray-700">
            D'origine française du département de l'Essonne nous embrassons
            l'individualité et nous soutenons la diversité. 
            Nous croyons fermement que chaque individu est unique, 
            avec une voix et un style qui lui sont propres. 
            Notre mission est de créer une expérience
            vestimentaire qui permet à chacun de s'exprimer librement et de se
            sentir confiant dans sa propre peau.
          </p>
        </div>
        <div className="w-full h-96 bg-black rounded-lg">
          <img
            src="/images/apropos/imgapropos.jpg"
            alt="imgapropos"
            className="w-full h-full object-cover rounded-lg"
            loading="lazy"
          />
        </div>
      </div>

      {/* Formulaire */}
      <div className="mt-16">
        <h3 className="text-xl font-semibold mb-6">Contact</h3>

        {success && (
          <div className="fixed top-1/2 right-4 z-50">
            <div
              className={`px-4 py-3 rounded shadow-lg text-white text-sm ${
                success.startsWith("✅") ? "bg-green-600" : "bg-red-500"
              }`}
            >
              {success}
            </div>
          </div>
        )}

        <form
          className="grid grid-cols-1 md:grid-cols-2 gap-6"
          onSubmit={handleSubmit}
        >
          <div>
            <label className="block text-sm font-medium mb-1">Prénom</label>
            <input
              type="text"
              name="firstName"
              value={form.firstName}
              onChange={handleChange}
              className="w-full border rounded-md px-4 py-2 text-sm"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">Nom</label>
            <input
              type="text"
              name="lastName"
              value={form.lastName}
              onChange={handleChange}
              className="w-full border rounded-md px-4 py-2 text-sm"
              required
            />
          </div>

          <div className="md:col-span-2">
            <label className="block text-sm font-medium mb-1">
              Adresse mail
            </label>
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              className="w-full border rounded-md px-4 py-2 text-sm"
              required
            />
          </div>

          <div className="md:col-span-2">
            <label className="block text-sm font-medium mb-1">Message</label>
            <textarea
              name="message"
              value={form.message}
              onChange={handleChange}
              className="w-full border rounded-md px-4 py-2 text-sm h-32"
              required
            />
          </div>

          <div className="md:col-span-2">
            <button
              type="submit"
              disabled={isSubmitting}
              className={`bg-black text-white px-6 py-2 rounded-md text-sm transition ${
                isSubmitting
                  ? "opacity-50 cursor-not-allowed"
                  : "hover:bg-gray-800"
              }`}
            >
              {isSubmitting ? "Envoi..." : "Envoyer"}
            </button>
          </div>
        </form>
      </div>
    </section>
  );
}
